export const LAC_TABS = [
  'users',
  'organisations',
  'chatbots',
  'documents',
  'website-crawls',
] as const;

export type LacTabId = (typeof LAC_TABS)[number];

export const DEFAULT_LAC_TAB: LacTabId = 'users';

export function isLacTabId(value: string | undefined): value is LacTabId {
  return value !== undefined && (LAC_TABS as readonly string[]).includes(value);
}

export function resolveLacTabPath(tabId: LacTabId = DEFAULT_LAC_TAB): string {
  return `/lac/${tabId}`;
}

export const LAC_TENANT_DETAILS_TABS = [
  'organisation',
  'costs',
  'users',
  'stats',
  'documents',
  'website-crawls',
] as const;

export type LacTenantDetailsTabId = (typeof LAC_TENANT_DETAILS_TABS)[number];

export const DEFAULT_LAC_TENANT_DETAILS_TAB: LacTenantDetailsTabId =
  'organisation';

export function isLacTenantDetailsTabId(
  value: string | undefined,
): value is LacTenantDetailsTabId {
  return (
    value !== undefined &&
    (LAC_TENANT_DETAILS_TABS as readonly string[]).includes(value)
  );
}

export function resolveLacTenantPath(
  tenantName: string,
  tabId: LacTenantDetailsTabId = DEFAULT_LAC_TENANT_DETAILS_TAB,
): string {
  return `/lac/organisations/${encodeURIComponent(tenantName)}/${tabId}`;
}

export function resolveLacUserProfilePath(
  tenantName: string,
  userRef: string,
): string {
  return `/lac/users/${encodeURIComponent(tenantName)}/${encodeURIComponent(userRef)}`;
}

/** Router location state for returning from a user profile. */
export type UserProfileLocationState = {
  backTo?: string;
};

export function getUserProfileBackPath(
  state: unknown,
  fallback: string,
): string {
  if (
    state != null &&
    typeof state === 'object' &&
    'backTo' in state &&
    typeof (state as UserProfileLocationState).backTo === 'string' &&
    (state as UserProfileLocationState).backTo !== ''
  ) {
    return (state as UserProfileLocationState).backTo!;
  }
  return fallback;
}
